/**
 * Activity log UI labels only (no Prisma / server code).
 * Safe to import from client components and from app/api/activity-log/route.ts.
 */

import type {
  ActivityActionTypeValue,
  ActivityPathValue,
  ActivityResultValue,
} from "@/types/activity-log";

export const ACTIVITY_ACTION_TYPE_LABELS: Record<
  ActivityActionTypeValue,
  string
> = {
  CONNECTION: "Connexion",
  DISCONNECTION: "Déconnexion",
  KVPS_CHANGE: "Changement KVPS",
  VEHICLE_SEARCH_INIT: "Init recherche véhicule",
  DRAFT_CREATE: "Création brouillon",
  DRAFT_UPDATE: "Modification brouillon",
  DRAFT_DELETE: "Suppression brouillon",
  CTM_VALIDATION: "Validation CTM",
};

export const ACTIVITY_RESULT_LABELS: Record<ActivityResultValue, string> = {
  OK: "OK",
  KO_METIER: "KO métier",
  KO_TECH: "KO technique",
};

export const ACTIVITY_PATH_LABELS: Record<ActivityPathValue, string> = {
  AVS: "AVS",
  RETAIL: "Retail",
  SYSTEM: "Système",
};

export function getActionTypeLabel(
  actionType: ActivityActionTypeValue | null,
): string {
  return actionType
    ? (ACTIVITY_ACTION_TYPE_LABELS[actionType] ?? actionType)
    : "—";
}

export function getResultLabel(result: ActivityResultValue | null): string {
  return result ? (ACTIVITY_RESULT_LABELS[result] ?? result) : "—";
}

export function getPathLabel(path: ActivityPathValue | null): string {
  return path ? (ACTIVITY_PATH_LABELS[path] ?? path) : "—";
}
